import { useQuery } from 'react-query'
import React, { Component } from "react";
import styled from "styled-components";
import { fetchUpgradesExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

async function fetch() {
    const { data } = await fetchUpgradesExplorer('byBreakdown')
    return data.result
}
function UpgradesByBreakdown() {
    const { data, error, isError, isLoading } = useQuery('upgradesUpsByBreakdown', fetch)
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer  {...dataProps } />
}
export default UpgradesByBreakdown